function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M123.175 164C161.809 164 193.128 132.796 193.128 94.3024C193.128 55.8093 161.809 24.6045 123.175 24.6045C84.5401 24.6045 53.2207 55.8093 53.2207 94.3024C53.2207 132.796 84.5401 164 123.175 164Z",
  fill: "#EDF1FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M155.749 71.7666H90.9843C90.0901 71.7666 89.3652 72.4888 89.3652 73.3798V124.997C89.3652 125.888 90.0901 126.61 90.9843 126.61H155.749C156.643 126.61 157.368 125.888 157.368 124.997V73.3798C157.368 72.4888 156.643 71.7666 155.749 71.7666Z",
  fill: "white",
  stroke: "#6ACCCE",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M137.939 94.3466C137.51 94.3466 137.098 94.1766 136.794 93.8741C136.491 93.5715 136.32 93.1612 136.32 92.7334V87.8938H133.082C131.794 87.8938 130.558 87.3839 129.647 86.4763C128.736 85.5687 128.225 84.3378 128.225 83.0542V63.696C128.225 62.4125 128.736 61.1815 129.647 60.2739C130.558 59.3663 131.794 58.8564 133.082 58.8564H158.988C160.276 58.8564 161.511 59.3663 162.422 60.2739C163.333 61.1815 163.845 62.4125 163.845 63.696V83.0542C163.845 84.3378 163.333 85.5687 162.422 86.4763C161.511 87.3839 160.276 87.8938 158.988 87.8938H148.14L138.833 94.0755C138.568 94.2514 138.257 94.3457 137.939 94.3466Z",
  fill: "#4D74FC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M115.271 105.638C120.742 105.638 124.986 99.568 124.986 94.3461C124.986 91.7791 123.962 89.3171 122.141 87.5019C120.319 85.6868 117.848 84.667 115.271 84.667C112.695 84.667 110.224 85.6868 108.402 87.5019C106.58 89.3171 105.557 91.7791 105.557 94.3461C105.557 99.568 109.8 105.638 115.271 105.638Z",
  fill: "#5FCAE4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M125.648 110.428C118.884 108.351 111.65 108.344 104.881 110.408C103.201 110.894 101.726 111.913 100.679 113.309C99.6325 114.706 99.0711 116.404 99.0802 118.147V120.157H131.462V118.171C131.47 116.426 130.907 114.726 129.858 113.329C128.808 111.931 127.331 110.913 125.648 110.428Z",
  fill: "#5FCAE4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M140.89 12.6793C144.127 12.6793 146.752 10.0648 146.752 6.83966C146.752 3.61451 144.127 1 140.89 1C137.653 1 135.029 3.61451 135.029 6.83966C135.029 10.0648 137.653 12.6793 140.89 12.6793Z",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M218.149 100.725C222.716 100.725 226.419 97.0356 226.419 92.4849C226.419 87.9342 222.716 84.2451 218.149 84.2451C213.582 84.2451 209.879 87.9342 209.879 92.4849C209.879 97.0356 213.582 100.725 218.149 100.725Z",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1 64.5761C1 63.3531 1.48761 62.1802 2.35557 61.3155C3.22352 60.4507 4.40072 59.9648 5.62819 59.9648C6.85566 59.9648 8.03285 60.4507 8.9008 61.3155C9.76875 62.1802 10.2564 63.3531 10.2564 64.5761",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4168 64.4258C19.4573 65.0549 19.3679 65.6856 19.1541 66.2789C18.9403 66.8723 18.6067 67.4156 18.1738 67.8754C17.741 68.3353 17.2181 68.7017 16.6375 68.9523C16.0568 69.2028 15.4308 69.3321 14.7981 69.3321C14.1654 69.3321 13.5394 69.2028 12.9588 68.9523C12.3782 68.7017 11.8553 68.3353 11.4224 67.8754C10.9896 67.4156 10.6559 66.8723 10.4421 66.2789C10.2283 65.6856 10.1389 65.0549 10.1794 64.4258",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4199 64.5761C19.4199 63.3531 19.9075 62.1802 20.7755 61.3155C21.6434 60.4507 22.8206 59.9648 24.0481 59.9648C25.2756 59.9648 26.4528 60.4507 27.3207 61.3155C28.1887 62.1802 28.6763 63.3531 28.6763 64.5761",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9871 64.4258C38.0276 65.0549 37.9382 65.6856 37.7244 66.2789C37.5106 66.8723 37.177 67.4156 36.7441 67.8754C36.3113 68.3353 35.7884 68.7017 35.2078 68.9523C34.6272 69.2028 34.0012 69.3321 33.3684 69.3321C32.7357 69.3321 32.1097 69.2028 31.5291 68.9523C30.9485 68.7017 30.4256 68.3353 29.9927 67.8754C29.5599 67.4156 29.2262 66.8723 29.0124 66.2789C28.7987 65.6856 28.7092 65.0549 28.7497 64.4258",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9883 64.5761C37.9883 63.3531 38.4759 62.1802 39.3438 61.3155C40.2118 60.4507 41.389 59.9648 42.6165 59.9648C43.8439 59.9648 45.0211 60.4507 45.8891 61.3155C46.757 62.1802 47.2446 63.3531 47.2446 64.5761",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M56.4813 64.4258C56.5218 65.0549 56.4323 65.6856 56.2185 66.2789C56.0047 66.8723 55.6711 67.4156 55.2383 67.8754C54.8054 68.3353 54.2825 68.7017 53.7019 68.9523C53.1213 69.2028 52.4953 69.3321 51.8626 69.3321C51.2298 69.3321 50.6038 69.2028 50.0232 68.9523C49.4426 68.7017 48.9197 68.3353 48.4869 67.8754C48.054 67.4156 47.7204 66.8723 47.5066 66.2789C47.2928 65.6856 47.2034 65.0549 47.2439 64.4258",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M185.51 128.745C185.51 127.522 185.997 126.349 186.865 125.484C187.733 124.62 188.91 124.134 190.138 124.134C191.365 124.134 192.543 124.62 193.411 125.484C194.279 126.349 194.766 127.522 194.766 128.745",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M203.925 128.595C203.965 129.224 203.876 129.855 203.662 130.448C203.448 131.041 203.114 131.585 202.682 132.044C202.249 132.504 201.726 132.871 201.145 133.121C200.565 133.372 199.939 133.501 199.306 133.501C198.673 133.501 198.047 133.372 197.467 133.121C196.886 132.871 196.363 132.504 195.93 132.044C195.497 131.585 195.164 131.041 194.95 130.448C194.736 129.855 194.647 129.224 194.687 128.595",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M203.93 128.745C203.93 127.522 204.417 126.349 205.285 125.484C206.153 124.62 207.33 124.134 208.558 124.134C209.785 124.134 210.963 124.62 211.831 125.484C212.698 126.349 213.186 127.522 213.186 128.745",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M222.495 128.595C222.535 129.224 222.446 129.855 222.232 130.448C222.018 131.041 221.685 131.585 221.252 132.044C220.819 132.504 220.296 132.871 219.716 133.121C219.135 133.372 218.509 133.501 217.876 133.501C217.244 133.501 216.618 133.372 216.037 133.121C215.456 132.871 214.933 132.504 214.501 132.044C214.068 131.585 213.734 131.041 213.52 130.448C213.306 129.855 213.217 129.224 213.258 128.595",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M222.496 128.745C222.496 127.522 222.984 126.349 223.852 125.484C224.72 124.62 225.897 124.134 227.124 124.134C228.352 124.134 229.529 124.62 230.397 125.484C231.265 126.349 231.752 127.522 231.752 128.745",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M240.989 128.595C241.03 129.224 240.94 129.855 240.726 130.448C240.513 131.041 240.179 131.585 239.746 132.044C239.313 132.504 238.79 132.871 238.21 133.121C237.629 133.372 237.003 133.501 236.37 133.501C235.738 133.501 235.112 133.372 234.531 133.121C233.95 132.871 233.428 132.504 232.995 132.044C232.562 131.585 232.228 131.041 232.014 130.448C231.801 129.855 231.711 129.224 231.752 128.595",
  stroke: "#60CAE3",
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M37.554 18.5416V42.0868C37.554 47.9044 43.4619 52.6527 50.7385 52.7017H64.2085L79.8645 61.6992L77.4127 52.7017H79.8645C87.1312 52.7017 93.0293 47.9534 93.0293 42.0868V18.5416C93.0293 12.6553 87.1214 6.20215 79.8645 6.20215H50.7188C43.4521 6.20215 37.554 12.6847 37.554 18.5416Z",
  fill: "white",
  stroke: "#6ACCCE",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M52.3609 34.7051C50.2291 34.7051 48.501 32.9833 48.501 30.8594C48.501 28.7355 50.2291 27.0137 52.3609 27.0137C54.4926 27.0137 56.2207 28.7355 56.2207 30.8594C56.2207 32.9833 54.4926 34.7051 52.3609 34.7051Z",
  fill: "#5FCAE4",
  stroke: "#6ACCCE",
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M65.1714 34.7051C63.0397 34.7051 61.3116 32.9833 61.3116 30.8594C61.3116 28.7355 63.0397 27.0137 65.1714 27.0137C67.3031 27.0137 69.0312 28.7355 69.0312 30.8594C69.0312 32.9833 67.3031 34.7051 65.1714 34.7051Z",
  fill: "#5FCAE4",
  stroke: "#6ACCCE",
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0972 34.7051C76.9655 34.7051 75.2374 32.9833 75.2374 30.8594C75.2374 28.7355 76.9655 27.0137 79.0972 27.0137C81.2289 27.0137 82.957 28.7355 82.957 30.8594C82.957 32.9833 81.2289 34.7051 79.0972 34.7051Z",
  fill: "#5FCAE4",
  stroke: "#6ACCCE",
  strokeMiterlimit: 10
});

function SvgEmptyCommentsState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 164,
    viewBox: "0 0 242 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCommentsState);
export default __webpack_public_path__ + "static/media/empty_comments_state.c30fef16.svg";
export { ForwardRef as ReactComponent };